import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "What We Remove", href: "#services" },
    { label: "How It Works", href: "#process" },
    { label: "Why Us", href: "#why-us" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setMobileOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white shadow-sm border-b border-dark-100"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8 lg:px-12 h-16 md:h-20">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2"
        >
          <div
            className={`w-8 h-8 rounded-lg flex items-center justify-center ${
              scrolled ? "bg-primary-600" : "bg-white/20 backdrop-blur-sm"
            }`}
          >
            <i
              className={`ri-bar-chart-grouped-line text-lg ${
                scrolled ? "text-white" : "text-white"
              }`}
            />
          </div>
          <span
            className={`font-heading font-bold text-base md:text-lg tracking-tight whitespace-nowrap ${
              scrolled ? "text-dark-950" : "text-white"
            }`}
          >
            Fastestcreditrestoration.com
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.href);
              }}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-dark-600 hover:text-primary-700 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:754-777-6321"
            className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
              scrolled
                ? "bg-primary-600 text-white hover:bg-primary-700"
                : "bg-white text-primary-700 hover:bg-primary-50"
            }`}
          >
            <i className="ri-phone-line mr-2" />
            Call Now
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 rounded-lg flex items-center justify-center transition-colors cursor-pointer ${
            scrolled
              ? "text-dark-700 hover:bg-dark-50"
              : "text-white hover:bg-white/10"
          }`}
        >
          <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-dark-100 shadow-lg">
          <div className="flex flex-col p-4 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="px-4 py-3 rounded-lg text-dark-700 hover:bg-primary-50 hover:text-primary-700 font-medium text-sm cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:754-777-6321"
              className="mt-2 px-4 py-3 rounded-lg bg-primary-600 text-white font-semibold text-sm text-center cursor-pointer"
            >
              <i className="ri-phone-line mr-2" />
              Call (754) 777-6321
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}